<template>
  <section class="editor-container">
    <quill-editor
      ref="myQuillEditor"
      v-model="content"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    />
    <v-upload
      v-show="false"
      ref="uploadInput"
      class="hide"
      :notUpload="true"
      @uploadForm="handlerUploadSuccess" />
  </section>
</template>
<script>
import { uploadNewsImage } from '@/api/news'

export default {
  name: 'VQuillEditor',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: '<h2>I am Example</h2>',
      editorOption: {
        // Some Quill options...
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link'],        // toggled buttons
            // ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            // [{ 'direction': 'rtl' }],                         // text direction
            [{ 'size': ['small', 'large','12px', '16px', '20px', '24px', '28px', '32px'] }],
            // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, false] }],
            [{ 'lineHeight': ['1', '1.5', '2', '2.5', '3'] }],
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [
              'lato',  
              'PingFangHK-Semibold',
              'PingFangHK-Regular',
              'Source Sans Pro',
              '-apple-system',
              'BlinkMacSystemFont',
              'Segoe UI',
              'Roboto',
              'Helvetica Neue',
              'Arial',
              'sans-serif'] }],
            [{ 'align': [] }],
            ['image'],
            // ['clean']
          ]
        }
      },
      addRange: ''
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if(val !== this.content) {
          this.$nextTick(() => {
            this.content = val
            // this.$refs.myQuillEditor.quill.setContents(val + '\n', 'user')
          })
        }
      }
    },
    content: {
      handler(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    // console.log('this is current quill instance object', this.editor)
    this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imgHandler)
  },
  methods: {
    onEditorBlur(quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      // console.log('editor ready!', quill)
    },
    imgHandler(state) {
      this.addRange = this.$refs.myQuillEditor.quill.getSelection()
      if(state) {
        this.$refs['uploadInput'].currentClick()
      }
    },
    handlerUploadSuccess({ params, result, otherData }) {
      this.network().uploadNewsImage({ params, result, otherData })
    },
    network() {
      return {
        uploadNewsImage: async ({ params, result, otherData }) => {
          params.append('type', 2)
          const { data } = await uploadNewsImage(params)
          const { url } = data
          const quill = this.$refs.myQuillEditor.quill
          const index = this.addRange? this.addRange.index: 0
          quill.insertEmbed(index, 'image', {
            src: url,
            alt: 'image',
            style: 'height: auto; max-width: 100%;'
          }, 'user')
          quill.setSelection(index+1)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.editor-container {
  position: relative;
  width: 100%;
  height: 100%;
  /deep/ .quill-editor {
    height: 100%;
    /deep/ .ql-toolbar.ql-snow + .ql-container.ql-snow {
      height: calc(100% - 100px);
   }
  }
  /deep/ .ql-container {
    background: white;
  }
  
    .ql-video {
        display: none!important;
    }
}
</style>
<style lang="scss">
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: '12px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: '16px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: '20px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: '24px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: '28px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: '32px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
  content: '36px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="40px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="40px"]::before {
  content: '40px';
}
.ql-snow {
  .ql-picker.ql-lineHeight {
    min-width: 35px;
    .ql-picker-label::before {
      content: '1'
    }
    .ql-picker-item::before {
      content: '1'
    }
    .ql-picker-label[data-value="1.5"]::before {
      content: '1.5'
    }
    .ql-picker-item[data-value="1.5"]::before {
      content: '1.5'
    }
    .ql-picker-label[data-value="2"]::before {
      content: '2'
    }
    .ql-picker-item[data-value="2"]::before {
      content: '2'
    }
    .ql-picker-label[data-value="2.5"]::before {
      content: '2.5'
    }
    .ql-picker-item[data-value="2.5"]::before {
      content: '2.5'
    }
    .ql-picker-label[data-value="3"]::before {
      content: '3'
    }
    .ql-picker-item[data-value="3"]::before {
      content: '3'
    }
  }
}
.ql-snow {
  .ql-picker.ql-font {
    .ql-picker-label::before {
      content: 'lato'
    }
    .ql-picker-item::before {
      content: 'lato'
    }
    .ql-picker-label[data-value="lato"]::before {
      content: 'lato'
    }
    .ql-picker-item[data-value="lato"]::before {
      content: 'lato'
    }
    .ql-picker-label[data-value="PingFangHK-Semibold"]::before {
      content: 'PingFangHK-Semibold'
    }
    .ql-picker-item[data-value="PingFangHK-Semibold"]::before {
      content: 'PingFangHK-Semibold'
    }
    .ql-picker-label[data-value="PingFangHK-Regular"]::before {
      content: 'PingFangHK-Regular'
    }
    .ql-picker-item[data-value="PingFangHK-Regular"]::before {
      content: 'PingFangHK-Regular'
    }
    .ql-picker-label[data-value="Source Sans Pro"]::before {
      content: 'Source Sans Pro'
    }
    .ql-picker-item[data-value="Source Sans Pro"]::before {
      content: 'Source Sans Pro'
    }
    .ql-picker-label[data-value="-apple-system"]::before {
      content: '-apple-system'
    }
    .ql-picker-item[data-value="-apple-system"]::before {
      content: '-apple-system'
    }
    .ql-picker-label[data-value="BlinkMacSystemFont"]::before {
      content: 'BlinkMacSystemFont'
    }
    .ql-picker-item[data-value="BlinkMacSystemFont"]::before {
      content: 'BlinkMacSystemFont'
    }
    .ql-picker-label[data-value="Segoe UI"]::before {
      content: 'Segoe UI'
    }
    .ql-picker-item[data-value="Segoe UI"]::before {
      content: 'Segoe UI'
    }
    .ql-picker-label[data-value="Roboto"]::before {
      content: 'Roboto'
    }
    .ql-picker-item[data-value="Roboto"]::before {
      content: 'Roboto'
    }
    .ql-picker-label[data-value="Helvetica Neue"]::before {
      content: 'Helvetica Neue'
    }
    .ql-picker-item[data-value="Helvetica Neue"]::before {
      content: 'Helvetica Neue'
    }
    .ql-picker-label[data-value="Arial"]::before {
      content: 'Arial'
    }
    .ql-picker-item[data-value="Arial"]::before {
      content: 'Arial'
    }
    .ql-picker-label[data-value="sans-serif"]::before {
      content: 'sans-serif'
    }
    .ql-picker-item[data-value="sans-serif"]::before {
      content: 'sans-serif'
    }
  }
}
</style>